"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePhone = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const changePhone = exports.changePhone = (0, _actionGenerator.actionGenerator)(_types.ESocialsActionTypes.PhoneChanged);